import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  public messages$: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  constructor() { }

  public updateMessages(messages: Array<any>) {
    this.messages$.next(messages);
  }
}
